import { Component } from '@angular/core';
import { TrelloService } from 'app/trello/services/trello.service';

@Component({
  selector: 'app-time-tracking-component',
  templateUrl: './time-tracking.component.html',
})
export class TimeTrackingComponent {

  constructor(
    private readonly trelloService: TrelloService, // required
  ) {
  }

}
